import { BRAND } from "@/lib/brand";

/**
 * Logo AAB Repairs — sempre monocromático (branco no dark, invertido no light).
 * O arquivo original tem fundo preto e formas brancas: aplicamos `invert` no light
 * para exibir formas pretas em fundo claro sem edição de imagem.
 */
export default function BrandLogo({ size = "md", showFiscal = false, className = "" }) {
  const heights = {
    sm: "h-8",
    md: "h-10",
    lg: "h-14",
    xl: "h-20",
  };
  return (
    <div className={`flex flex-col ${className}`} data-testid="brand-logo">
      <img
        src={BRAND.logoUrl}
        alt={`${BRAND.legalName} — ${BRAND.tagline}`}
        className={`${heights[size]} w-auto object-contain invert dark:invert-0 select-none`}
        draggable={false}
      />
      {showFiscal && (
        <span className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground mt-1.5">
          {BRAND.fiscalName}
        </span>
      )}
    </div>
  );
}
